import type { FaireProductEntity } from "../../entity_types/product";

export const p_9bacm33g6k: FaireProductEntity = {
  token: "p_9bacm33g6k",
  type: "product",
  name: "Craft Glass Soda | Batch Snozzberry Soda 24 Count",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl:
    "https://cdn.faire.com/fastly/e9dcaf1ba538dff4373a9a1be82e4c7950d048963c4d20afaecb02cde2d27337.jpeg",
  galleryImageUrls: [],
  priceDollars: 73.16,
  description:
    "Bring imaginative craft flavor to your inventory with Craft Glass Soda Batch Snozzberry Soda 24 Count from Mr YuYu’s Wholesale. This artisanal soda blends playful berry notes with creative flavor layering, delivering a memorable taste experience that delights adventurous consumers.\n\nBottled in premium glass, Batch Snozzberry preserves carbonation and flavor integrity while providing an eye-catching, high-quality drinking experience. Its whimsical, unconventional profile appeals to customers seeking unique craft beverages that stand out from standard options.\n\nIdeal for wholesale buyers, specialty retailers, cafés, events, and resale environments, this 24-count case is a high-demand product that differentiates your inventory. Stocking Batch Snozzberry ensures customers enjoy innovative, conversation-worthy craft soda experiences with every bottle.\n\nWith Mr YuYu’s Wholesale, businesses can offer artisanal beverages that combine premium ingredients, distinctive flavor profiles, and elevated presentation.\n",
  tags: [],
  msrpDollars: 146.33,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:57.588Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
